/* eslint-disable padding-line-between-statements */
import {EmbeddingType} from 'common/src/modules/ragSearch/ragSearch.enums';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {z} from 'zod';
import {AccountVertical, CampaignToolName} from '../copilotCampaigns.enums';
import {briefSchema} from '../copilotCampaigns.schemas';
import invokeRagArticleSearch from 'common/src/modules/shared/copilot/utils/invokeRagArticleSearch';

const inputSchema = z.object({
  campaignName: z.string().describe('The name of the campaign'),
  brief: briefSchema.describe('The campaign brief'),
  accountVertical: z.nativeEnum(AccountVertical).describe('The account vertical'),
  prompt: z
    .string()
    .describe("The user's exact prompt or question. Do not add any additional text to it."),
});

function strategyKnowledgeTool() {
  async function execute({
    input,
    abortSignal,
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const {accountVertical, campaignName, prompt, brief} = input;

    const context = `Account vertical is '${accountVertical}'.
  Campaign name is '${campaignName}'
  Brief is:
  ${JSON.stringify(brief)}`;

    const response = await invokeRagArticleSearch({
      prompt,
      context,
      embeddingTypes: [EmbeddingType.StrategyDocumentation],
      abortSignal,
    });

    return response;
  }

  return tool({
    name: CampaignToolName.StrategyKnowledge,
    displayName: 'Reading strategy knowledge',
    description:
      'Returns the most relevant articles regarding decision strategies. Relevance of each article is between 0-1',
    execute,
    inputSchema,
  });
}

export default strategyKnowledgeTool;
